// Central site data for AXAL Logistics
export const CONTACT = {
  phoneDisplay: "+39 324 551 5015",
  phoneRaw: "+393245515015",
  whatsappNumber: "393245515015",
  landlineDisplay: "+39 06 92949896",
  landlineRaw: "+390692949896",
  email: "axal.log@gmail.com",
};

export const GOOGLE_REVIEWS_URL = "https://share.google/r8v1s0qerQA3whpX9";

export const waLink = (text = "Ciao AXAL, vorrei informazioni su un trasporto.") =>
  `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent(text)}`;

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Servizi", to: "/servizi" },
  { label: "Traslochi", to: "/traslochi" },
  { label: "Trasporti", to: "/trasporti" },
  { label: "Spedizione Moto", to: "/spedizione-moto" },
  { label: "Azienda", to: "/azienda" },
  { label: "Recensioni", to: "/recensioni" },
  { label: "Contatti", to: "/contatti" },
];

export const IMAGES = {
  heroFleet: "https://static.prod-images.emergentagent.com/jobs/2eb9b7d7-d838-41a1-a063-3aab98062d0f/images/089acf128019fd74901e6b3e907cbd611450b3d57ac0afe0bf5306b649b76abc.jpeg",
  heroTruck: "https://static.prod-images.emergentagent.com/jobs/2eb9b7d7-d838-41a1-a063-3aab98062d0f/images/089acf128019fd74901e6b3e907cbd611450b3d57ac0afe0bf5306b649b76abc.jpeg",
  trasporti: "/fleet-axal.jpg",
  traslochi: "https://images.pexels.com/photos/7464722/pexels-photo-7464722.jpeg?auto=compress&cs=tinysrgb&w=1200",
  traslochiRoom: "https://images.unsplash.com/photo-1560185127-6ed189bf02f4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  moto: "https://static.prod-images.emergentagent.com/jobs/2eb9b7d7-d838-41a1-a063-3aab98062d0f/images/73928140af88a1aec5e681569a4a111ad4388d4ffb01d958c549e582b90b21a8.jpeg",
  motoStrap: "https://static.prod-images.emergentagent.com/jobs/2eb9b7d7-d838-41a1-a063-3aab98062d0f/images/bade6469a8c16446f73c78c8d29089154974250bbaacc2cc6210fb4f3568d465.jpeg",
  motoScooter: "https://static.prod-images.emergentagent.com/jobs/2eb9b7d7-d838-41a1-a063-3aab98062d0f/images/2a191e08150d6e02903fc979427d7f6f89750e1fe75781cb22dc2e8c9f2de456.jpeg",
  spedizioni: "https://images.pexels.com/photos/4487484/pexels-photo-4487484.jpeg?auto=compress&cs=tinysrgb&w=1200",
  deposito: "https://images.unsplash.com/photo-1586528116022-aeda1613c63d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  autoscala: "https://static.prod-images.emergentagent.com/jobs/2eb9b7d7-d838-41a1-a063-3aab98062d0f/images/28e3b0221d6a931c18032506c762f249dbf68bbdae8e8b7e54347209d73de16d.jpeg",
  business: "https://images.unsplash.com/photo-1664382953403-fc1ac77073a0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  warehouse: "https://images.unsplash.com/photo-1586528116022-aeda1613c63d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  movers: "https://images.pexels.com/photos/7464393/pexels-photo-7464393.jpeg?auto=compress&cs=tinysrgb&w=1200",
};

export const SERVICES = [
  { key: "trasporti", icon: "Truck", title: "Trasporti nazionali", desc: "Trasporti professionali e servizi groupage in tutta Italia.", img: IMAGES.trasporti, to: "/trasporti" },
  { key: "traslochi", icon: "Home", title: "Traslochi", desc: "Dal semplice trasporto al servizio completo con smontaggio, imballaggio e rimontaggio.", img: IMAGES.traslochi, to: "/traslochi" },
  { key: "moto", icon: "Bike", title: "Spedizione Moto", desc: "Trasporto dedicato per moto, scooter e veicoli a due ruote.", img: IMAGES.moto, to: "/spedizione-moto" },
  { key: "spedizioni", icon: "Package", title: "Spedizioni", desc: "Soluzioni per privati, professionisti e aziende.", img: IMAGES.spedizioni, to: "/servizi" },
  { key: "deposito", icon: "Warehouse", title: "Deposito merci", desc: "Deposito temporaneo e gestione delle merci.", img: IMAGES.deposito, to: "/servizi" },
  { key: "autoscala", icon: "Construction", title: "Autoscala & piattaforme", desc: "Noleggio con operatore per traslochi e movimentazioni ai piani.", img: IMAGES.autoscala, to: "/servizi" },
];

export const STATS = [
  { value: "200+", label: "Recensioni Google" },
  { value: "4,9/5", label: "Valutazione clienti" },
  { value: "Italia", label: "Copertura nazionale" },
  { value: "H24", label: "Assistenza dedicata" },
];

export const WHY = [
  { icon: "Users", title: "Personale qualificato", desc: "Operatori specializzati nella movimentazione." },
  { icon: "CalendarCheck", title: "Trasporto organizzato", desc: "Programmazione e coordinamento di ogni servizio." },
  { icon: "MessageCircle", title: "Assistenza diretta", desc: "Contatto WhatsApp e telefonico con AXAL." },
  { icon: "Settings2", title: "Soluzioni personalizzate", desc: "Dal singolo collo al trasloco completo." },
];

export const STEPS = [
  { n: "01", title: "Raccontaci cosa devi trasportare", desc: "Indica partenza, destinazione e caratteristiche del servizio." },
  { n: "02", title: "Ricevi il preventivo", desc: "Il nostro reparto preventivi valuta la soluzione più adatta." },
  { n: "03", title: "Organizziamo il trasporto", desc: "AXAL pianifica il servizio e comunica il passaggio." },
  { n: "04", title: "Consegna", desc: "La merce raggiunge la destinazione con assistenza dedicata." },
];

export const MOVING_ITEMS = ["Smontaggio mobili", "Imballaggio", "Inscatolamento", "Fornitura scatole", "Trasporto", "Facchinaggio", "Rimontaggio", "Autoscala", "Deposito"];

export const BUSINESS_SECTORS = ["negozi", "showroom", "studi di architettura", "case d'asta", "arredamento", "e-commerce", "aziende", "attività commerciali"];

export const ROUTES_LIST = ["Roma → Milano", "Roma → Napoli", "Roma → Bologna", "Roma → Firenze", "Milano → Roma", "Nord Italia → Centro Italia"];

export const REVIEWS = [
  { name: "Marco Bianchi", city: "Roma", text: "Trasloco impeccabile. Puntuali, professionali e attentissimi con i mobili. Consigliatissimi!", rating: 5 },
  { name: "Giulia Ferrari", city: "Milano", text: "Ho spedito la mia moto da Milano a Roma. Imballaggio perfetto e consegna nei tempi. Servizio top.", rating: 5 },
  { name: "Andrea Russo", city: "Napoli", text: "Azienda seria e strutturata. Assistenza sempre presente prima e dopo il trasporto.", rating: 5 },
  { name: "Francesca Romano", city: "Firenze", text: "Preventivo chiaro e trasparente, nessuna sorpresa. Operatori gentili e velocissimi.", rating: 5 },
  { name: "Luca Esposito", city: "Bologna", text: "Abbiamo affidato ad AXAL la logistica del nostro showroom. Precisi e affidabili.", rating: 5 },
  { name: "Sara Conti", city: "Torino", text: "Servizio autoscala per un trasloco al quarto piano: tutto perfetto e in sicurezza.", rating: 5 },
];
